<template>
  <v-row>
    <v-dialog
      v-model.sync="mDialog"
    >
      <v-card>
        <v-card-title class="headline">{{email.title}}</v-card-title>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit="submit"
        >
        <v-container grid-list-md>
          <v-row>
            <v-col xs="12" md="4">
              <v-text-field 
                :autofocus="true"
                :rules="senderRules" 
                required
                type="email"
                v-model="sender" 
                label="Remetente"
                :counter="250"
              >
              </v-text-field>
            </v-col>
            
            <v-col xs="12" md="4">
              <v-text-field               
                :rules="titleRules" 
                required 
                v-model="title" 
                label="Título da mensagem"
                :counter="250"
              >
              </v-text-field>
            </v-col>

            <v-col xs="12" md="4">
              <v-select
                v-model="schedule"
                :items="[
                {
                  text: 'Diariamente',
                  value: 1,
                },
                {
                  text: 'Mensalmente',
                  value: 2,
                },
                {
                  text: 'Selecionar data para envio',
                  value: 3,
                },
                {
                  text: '# dias após data do pedido',
                  value: 4,
                },
                ]"
                label="Agendar envio"
                required
                :rules="scheduleRules"
              ></v-select>
            </v-col>
            <v-col xs="12" md="4">
              <v-select
              v-model="lead_segments"
              :items="$store.state.leadSegmentations.map(s => {
                return {text: s.name, value: s.id}
              })"
              label="Destinatários"
              required
              :rules="arrayRequired"
              @input="resetValidation"
              chips
              multiple
              ></v-select>
            </v-col>
            <v-col xs="12" md="4">
              <v-switch v-model="active" label="Ativo"></v-switch>
            </v-col>
            <v-col xs="12">
              <label for="email-content">Corpo da Mensagem</label>
              <Editor id="email-content" :initialContent="content" @contentChanged="onContentChange"/>
              <v-text-field                             
              required
              v-model="content"
              type="hidden"
              ></v-text-field>
            </v-col>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="default"
                @click="reset"
                >
                Limpar formulário
              </v-btn>
              <v-btn
                :disabled="!valid"
                color="success"
                type="submit"          
              >
                Atualizar
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</v-row>
</template>

<script>
  import Editor from './Editor';
  export default {

    name: 'LeadSegmentEdit',
    components: {
      Editor
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      },
      email: {
        type: Object,
        default: null
      }
    },
    computed: {
      mDialog: {
        get() {
          return this.dialog;
        },
        set(value) {          
          this.$emit('closeEdit');
        }
      },
    },
    data () {      
      return {
        sender: this.email.sender || '',
        title: this.email.title || '',
        schedule: this.email.schedule || '',
        content: this.email.content ||'',
        active: this.email.active || false,
        lead_segments: (this.email.lead_segments && this.email.lead_segments.map(e => e.id)) || [],

        valid: false,
        senderRules: [
          v => !!v || 'Campo obrigatório',
        ],
        titleRules: [
          v => !!v || 'Campo obrigatório',
        ],
        scheduleRules: [
          v => !!v || 'Campo obrigatório',
        ],
        arrayRequired: [
          v => v && v.length > 0 || 'Escolha um item da lista'
        ]
      }
    },
    methods: {
      onContentChange(content) {
        this.content = content;
      },
      submit(e) {
        e.preventDefault();      
        if (this.$refs.form.validate()) {
          const form = {
            data: {
              sender: this.sender,
              title: this.title,
              schedule: this.schedule,
              content: this.content,
              lead_segments: this.lead_segments,
              active: this.active,
              id: (this.email && this.email.id) || null
            }
          }          
          this.$store.dispatch('createEmail', form);          
          this.reset();
        }
      },
      validate () {
        return this.$refs.form.validate();
      },
      reset () {

      },
      resetValidation () {
        this.$refs.form.resetValidation();
      },
    }
  }
</script>

<style lang="css" scoped>
</style>